//import liraries
import React, { useEffect, useState } from "react";
import {
  View,
  Text,TouchableOpacity,
  Image,
  TextInput,
} from "react-native";
import QuickLinks from "../Profile/QuickLinks";
import CustomButton from "../../common/CustomButton";
import { getPoolAccountdetail, getAutoRechargeDtls, updateAutoRechargeStatus, } from "../../api/apiManager";
import * as RootNavigation from "../../utilities/RootNavigation";
import ModalAlertForTwoButtons from "../../common/ModalAlertForTwoButtons";
import ModalAlert from "../../common/ModalAlert";
import moment from "moment";
import { get } from "lodash";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import { Outlet, useLocation } from "react-router-dom";
import useStyles from "./PoolAccount_Home_Styles";
import Loader from "../../common/Loader";


const PoolToTag_Home = (props) => {
  const styles = useStyles();
  const location = useLocation();
  const { state} = useLocation()
  const currentPath = location.pathname.split("/")[3];
  const [selectedLayout, setSelectedLayout] = useState("Pool Home");
  const [selectedValue, setSelectedValue] = useState("");
  const [data, setData] = useState({});
  const [maskedAccNum, setMaskedAccNum] = useState("");
  const [switched, setSwitched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errModalVisible, setErrModalVisible] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "Auto Recharge is active. Would you like to edit or disable it?",
    navigateScreen: "",
    actionButton: "",
  });
  const [connfirmDisable, setConfirmDisable] = useState(false);
  const [ccdata, setccData] = useState([]);

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

  useEffect(() => {
    getAutoRechargeDetails();
  }, [state?.isAutoRechEnabled]);
  

  const updateCreditStatus = () => {
    var params = {
      isAutoRechEnabled: "N",
      vrn: "",
      poolAccountNumber: data?.accountNo,
    };
    setLoading(true);
    updateAutoRechargeStatus(params)
      .then((res) => {
        if (res.statusCode == 1003 || res.statusCode == 200) {
          setLoading(false);
          setAlertModal({
            title: "Successful",
            status: "success",
            message:
              "As per your request, we have disabled Auto Recharge for your FASTag wallet.",
            navigateScreen: "HomeScreen",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          getAutoRechargeDetails(data?.accountNo);
        } else if (
          res.statusCode == -1052 ||
          res.statusCode == 500 ||
          res.statusCode == -1017 ||
          res.statusCode == -1003 ||
          res.statusCode == -1004
        ) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "HomeScreen",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedLayout == "Pool Home") {
      getPoolAccountDtls();
    }
  }, [selectedLayout]);

  const getAutoRechargeDetails = (accountNo) => {
    setLoading(true);
    let params = {
      vrn: "",
      poolAccountNumber: accountNo,
    };
    getAutoRechargeDtls(params)
      .then((res) => {
        console.log("res", res);
        setccData(res.data);
        setSwitched(res?.data?.isAutoRechEnabled == "N" ? false : true);
      })
      .catch(() => { })
      .finally(() => {
        setLoading(false);
      });
  };


  const getMaskedNum = (string) => {
    var new_string = string.replace(
      /\b[\dX][-. \dX]+(\d{4})\b/g,
      function (match, capture) {
        return Array(match.length - 4).join("X") + capture;
      }
    );
    return new_string;
  };
  useEffect(() => {
    if(props?.params){setSelectedLayout(props?.params);}
  }, [props?.params]);

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setData(res || {});
        getAutoRechargeDetails(res?.accountNo);
        setMaskedAccNum(getMaskedNum(res?.accountNo || ""));
        AsyncStorageFunc.storeData("poolSelection", res?.autopayEnabledFlag);
      })
      .catch((err) => {
        setLoading(false);

      });
  };


  return <View>
   
    
    {
      (currentPath != undefined) ? <Outlet /> : <View style={styles.mainContainer}>
      <View style={styles.iconContainer}>
        <Text style={styles.textStyle}>{"POOL ACCOUNT"}</Text>
        <View style={styles.backIconViewStyle}>
          <Text style={styles.autoRechargeTextStyle}>{"Auto Recharge"}</Text>
          <TouchableOpacity
            style={{
              backgroundColor: switched ? "#00d54f" : "#eeeeee",
              width: 44,
              height: 21,
              borderRadius: 11.7,
              justifyContent: "center",
            }}
            onPress={() =>
              switched
                ? setErrModalVisible(true)
                : RootNavigation.navigate('Profile/PoolAccount/AutoRecharge')
            }
          >
            <View
              style={{
                width: 18.8,
                height: 18.8,
                borderRadius: 9.4,
                backgroundColor: "#ffffff",
                marginHorizontal: 1,
                alignSelf: switched ? "flex-end" : "flex-start",
              }}
            />
          </TouchableOpacity>
        </View>
        
      </View>
      <View style={styles.bodyStyle}>
        <View>
          <Text style={styles.overViewStyle}>Pool Account Overview</Text>
          <View style={styles.containerBorder}>
            <View style={styles.cardContainer}>
              <Image
                source={require("../../assets/images/Card_Image_Pool.png")}
                style={{ width: 82, height: 84 }}
              />
              <View style={styles.innerContainer}>
                <Text
                  style={styles.cardNUmberTextStyle}
                  onPress={() => {
                    setMaskedAccNum(data?.accountNo);
                    setTimeout(() => {
                      setMaskedAccNum(getMaskedNum(data?.accountNo));
                    }, 30000);
                  }}
                >

                  {maskedAccNum}
                </Text>
                <Text style={styles.poolAcTextStyle}>Pool Account No.</Text>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginVertical: 15,
                  }}
                >
                  <Image
                    source={require("../../assets/images/ic_toll.png")}
                    style={{ width: 33, height: 26, color: "#601828" }}
                  />
                  <View
                    style={{
                      marginLeft: 10,
                    }}
                  >
                    <Text style={styles.amountTextStyle}>
                      {get(data, "accountBal", 0).toFixed(2)}
                    </Text>
                    <Text style={[styles.poolAcTextStyle, { paddingTop: 3 }]}>
                      Pool Account Bal.
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View style={styles.customButtonView}>
              <View style={styles.buttonViewStyle}>
                <CustomButton
                  text="Recharge"
                  onPress={() => {
                
                    RootNavigation.navigate('Recharge', {
                      screen: "Recharge",
                      poolAcnt: data?.accountNo,
                    })
                    global.activeScreen = "Recharge"
                  }}
                />
              </View>
              <View style={styles.buttonViewStyle}>
                <CustomButton
                  text="Transfer"
                  onPress={
                    data?.autopayEnabledFlag == "N"
                      ? () => {
                        RootNavigation.navigate('Profile/PoolAccount/TransferPool', {value: selectedValue})
                      }
                      : ()=>{}
                  }
                  disable={data?.autopayEnabledFlag == "N" ? false : true}
                />
              </View>
            </View>
          </View>
        </View>
        <View>
          <Text style={styles.overViewStyle}>{"Pool Account Details "}</Text>
          <View style={styles.textInputView}>
            <View style={styles.poolAcNum}>
              <Text style={styles.labelTextStyle}>Pool Account Number</Text>
              <TextInput
                style={styles.poolNumber}
                placeholder="25855868634553"
                value={maskedAccNum}
              />
            </View>

            <View style={styles.poolAcNum}>
              <Text style={styles.labelTextStyle}>Date Opened</Text>
              <TextInput
                style={styles.poolNumber}
                placeholder="20/07/2017"
                value={moment(data?.openedDt).format("DD/MM/YYYY")}
              />
            </View>
            <View style={styles.changePoolViewStyle}>
              <TouchableOpacity
                style={styles.poolAccountView}
                onPress={() => {
                
                  RootNavigation.navigate('Profile/PoolAccount/ChangeManual')
                }}
              >
                <Text style={styles.labelTextStyle}>Pool Account Type</Text>
                <TextInput
                  style={styles.poolNumber}
                  value={data?.autopayEnabledFlag == "N" ? "Manual" : "Auto"}
                  placeholder=""
                />
                <View
                  style={{
                    position: "absolute",
                    zIndex: 9,
                    right: 5,
                    bottom: 7,
                  }}
                >
                  <Text style={styles.changeTextStyle}>{"Change"}</Text>
                </View>
              </TouchableOpacity>
            </View>
          </View>

          <View style={styles.minThresholdView}>
            <View style={styles.poolAcNum}>
              <Text style={styles.labelTextStyle}>Min Threshold</Text>
              <TextInput
                style={styles.poolNumber}
                value={data?.minThresholdAmt ? data?.minThresholdAmt : "NA"}
                placeholder="600.00"
              />
            </View>

            <View style={styles.poolAcNum}>
              <Text style={styles.labelTextStyle}>Last Txn Date</Text>
              <TextInput
                style={styles.poolNumber}
                value={moment(data?.lastTxnDt).format("DD/MM/YYYY")}
                placeholder=""
              />
            </View>
          </View>
    
          <View style={styles.mobilePoolChange}>
            <TouchableOpacity
              style={styles.poolAccountView}
              onPress={() => {
            
                RootNavigation.navigate('Profile/PoolAccount/ChangeManual')
              }}
            >
              <Text style={styles.labelTextStyle}>Pool Account Type</Text>
              <TextInput
                style={styles.poolNumber}
                value={data?.autopayEnabledFlag == "N" ? "Manual" : "Auto"}
                placeholder=""
              />
              <View
                style={{
                  position: "absolute",
                  zIndex: 9,
                  right: 5,
                  bottom: 7,
                }}
              >
                <Text style={styles.changeTextStyle}>{"Change"}</Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <QuickLinks
        navigation={props.navigation}
        activeScreen={"Pool Account Details"}
        setScreen={(layout) => props.setScreen(layout)}
        setIsManual={(layout) => {
       
          RootNavigation.navigate('Profile/PoolAccount/PoolAccountDetails')
        }}
        setSelectedLayout={setSelectedLayout}
      />
      {errModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton1={"Edit"}
            actionButton2={"Disable"}
            onPressActionButton1={() => {
             
              RootNavigation.navigate('Profile/PoolAccount/AutoRecharge')
              setErrModalVisible(false);
            }}
            onPressActionButton2={() => {
              setConfirmDisable(true);
              setErrModalVisible(false);
            }}
            closeModal={true}
            onCloseModal={() => {
              setErrModalVisible(false);
            }}
          />
        </View>
      ) : null}

      {connfirmDisable ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            title={"Alert"}
            status={"error"}
            message={
              "Are you sure you want to disable Auto-Recharge. You can turn it on again later"
            }
            navigateScreen={alertModal.navigateScreen}
            actionButton1={"Cancel"}
            actionButton2={"Disable"}
            onPressActionButton1={() => {
              setConfirmDisable(false);
            }}
            onPressActionButton2={() => {
              updateCreditStatus();
              setConfirmDisable(false);
            }}
          />
        </View>
      ) : null}
       {loading ? <Loader /> :<></>}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
    </View>
    }
  </View>



};
export default PoolToTag_Home;
